import { parse } from 'graphql';

export const ReorderDataDocument = parse(`
  query ReorderData($transactionId: String!) {
      orderByTransactionId(transaction_id: $transactionId) {
          date_of_birth
          first_name
          gender
          last_name
          phone
          email
          leave_message
          send_sms
          lab {
            id
            title
            country
            address
            address2
            city
            state
            zip_code
            phone: phone_number
            hours
            latitude
            longitude
            network {
              name
              display_name
            }
          }
          tests {
            customer_tests_name
            is_test_or_panel
            customer_tests_type
            customer_tests_price
            test {
              id 
              name
              type
              price 
              slug 
            }
          }
          consultation_requests {
            pharmacy
            allergies
            prescriptions
            health_info
            treatment {
              id
            }
          }
      }
    }
`);
